import cn from 'classnames'

import './styles.scss'

interface Props {
  className?: string
}

export const DotsLoader = ({ className }: Props) => (
  <div className={cn('dots-loader', className)}>
    <span></span>
    <span></span>
    <span></span>
  </div>
)
